<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->

    <!-----------footer--------------->
    <section class="contact_page pdb_70 pdt_100">
       <div class="container">
          <div class="row">
             <!---------row----------->

            <div  iv class="col-lg-6">
                <img src="assets/image/update.png" class="img-fluid">
            </div>

             <div class="col-lg-6 col-md-12 mx-auto">

                
                <!---------col----------->
                <div class="contact_us_form">
                    <h2 class="update-recod-heading text-left mt-5">Update Record</h2>
                   <div class="form_box type_one">
                      <form  [formGroup]="appointmentForm" (ngSubmit)="submitForm(appointmentForm.value)">
                         <div class="messages"></div>
                         <div class="controls">
                            <div class="row">
                               <div class="col-lg-12">
                                  <div class="form-group">
                                     <input type="text" formControlName="appointmentId" class="percent_100 login_input_padding" maxlength="15" name="name" 
                                     [ngClass]="{ 'is-invalid': submitted &amp;&amp; appointmentForm.controls.appointmentId.errors }"
                                            placeholder="Appointment ID">
                                        <div *ngIf="submitted &amp;&amp; appointmentForm.controls.appointmentId.errors" class="form-text text-danger">
                                              
                                            <div *ngIf="appointmentForm.controls.appointmentId.errors.minlength">A minimum of 7 character required</div>
                                            <div *ngIf="appointmentForm.controls.appointmentId.errors.pattern">Please enter a valid Appointment ID</div>
                                            <div *ngIf="appointmentForm.controls.appointmentId.errors.required">Appointment ID is reuired</div>
                                        </div>
                                  
                                     <!-- <div class="help-block with-errors"></div> -->
                                  </div>
                               </div>
                               
                           
                               <div class="col-lg-12">
                                  <div class="form-group text-center mt-4">
                                     <button type="submit"  class="theme_btn tp_two logo-button-website">Submit</button>
                                     <button type="button" (click)="viewModal(inboundModal)" id="loadInboundModal"
                                      class="theme_btn tp_two logo-button-website d-none">Submit</button>
                                      <button type="button" (click)="viewModal(outboundModal)" id="loadOutboundModal"
                                      class="theme_btn tp_two logo-button-website d-none">Submit</button>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </form>
                   </div>
                </div>
                <!---------col-end---------->
             </div>

          
             <!----------row-end---------->
          </div>
       </div>
    </section>
<app-footer></app-footer>
    
</main>
<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>


  <ng-template let-modal #inboundModal>
    <!-- Modal -->
    <div class=""  >
      <div class="m">
        <div class="modal-content">
          <div class="modal-header-custom">
            <h5 class="modal-title" id="exampleModalLongTitle">Update Record For {{appointmentId}}</h5>
            <button type="button" (click)="modal.close('Save click')">
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
          <div class="modal-body">
            
             
                  <!-- popup form start -->
  
                  <form [formGroup]="inboundForm" (ngSubmit)="submitInboundForm(inboundForm.value)">
  
                      <div class="form-row">
                        <div class="form-group col-md-4">
                          <label for="inputEmail4">Passanger Name</label>
                          <input type="text" class="form-control" readOnly formControlName="name" id="inputEmail4">
                        </div>
                        <div class="form-group col-md-4">
                          <label for="inputPassword4">Passport No.</label>
                          <input type="text" class="form-control" readOnly formControlName="passportNumber" id="inputPassword4">
                        </div>
                        <div class="form-group col-md-4">
                          <label for="inputEmail4">Email</label>
                          <input type="email" class="form-control" readOnly formControlName="email" id="inputEmail4">
                        </div>
                      </div>
   
                      
                      <div class="form-row">
                          <div class="form-group col-md-4">
                            <label for="inputPassword4">Phone No.</label>
                            <input type="text" class="form-control" readOnly formControlName="phone" id="inputPassword4">
                          </div>
                          <div class="form-group col-md-4">
                            <label for="inputEmail4">Arrival Date</label>
                            <input type="date" formControlName="arrivalDate" class="form-control" id="inputEmail4"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; inboundForm.controls.arrivalDate.errors }">
                              <div *ngIf="submitted &amp;&amp; inboundForm.controls.arrivalDate.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="inboundForm.controls.arrivalDate.errors.required"> Arrival Date is required</div>
                              </div>
                             

                          </div>
                          <div class="form-group col-md-4">
                            <label for="inputPassword4">Collection Center</label>
                            <select type="date" formControlName="center" class="form-control" id="inputPassword4"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; inboundForm.controls.center.errors }">
                              <option value="">Select Collection Center</option>
                              <option *ngFor="let center of collectionCenters?.data" value="{{center?.id}}">{{center.name }} </option>  
                            </select>
                              <div *ngIf="submitted &amp;&amp; inboundForm.controls.center.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="inboundForm.controls.center.errors.required">Collection Center is required</div>
                              </div>
                          </div>
                        </div>
  
  
  
  
                        <div class="form-row">
                          <div class="form-group col-md-3">
                              <label for="inputState">Expected State</label>
                              <input id="inputState" formControlName="expectedState" class="form-control"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; inboundForm.controls.expectedState.errors }">
                              <div *ngIf="submitted &amp;&amp; inboundForm.controls.expectedState.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="inboundForm.controls.expectedState.errors.required"> Expected State is required</div>
                              </div> 
                            </div>
                            <div class="form-group col-md-3">
                              <label for="inputCity">Expected City</label>
                              <input id="inputCity" formControlName="expectedCity" class="form-control"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; inboundForm.controls.expectedCity.errors }">
                              <div *ngIf="submitted &amp;&amp; inboundForm.controls.expectedCity.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="inboundForm.controls.expectedCity.errors.required"> Expected City is required</div>
                              </div>
                            </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">Booking Date</label>
                            <input type="Date" class="form-control" formControlName="bookingDate" id="inputPassword4"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; inboundForm.controls.bookingDate.errors }">
                              <div *ngIf="submitted &amp;&amp; inboundForm.controls.bookingDate.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="inboundForm.controls.bookingDate.errors.required"> Booking Date is required</div>
                              </div>
                          </div>
                          <div class="form-group col-md-3">
                              <label for="inputPassword4">Booking Time</label>
                              <input type="time" class="form-control" formControlName="bookingTime" id="inputPassword4"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; inboundForm.controls.bookingTime.errors }">
                              <div *ngIf="submitted &amp;&amp; inboundForm.controls.bookingTime.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="inboundForm.controls.bookingTime.errors.required"> Booking Time is required</div>
                              </div>
                            </div>
                        </div>
  
   
                     
                        <div class=" text-center pb-5">
                          
                          <button type="submit" class="theme_btn tp_two logo-button-website  ">Save changes</button>
                        </div>
                    </form>
  
                  <!-- popup form end--> 
          </div>
        </div>
      </div>
    </div>

  </ng-template>

  <ng-template let-modal #outboundModal>
    <!-- Modal -->
    <div class=""  >
      <div class="m">
        <div class="modal-content">
          <div class="modal-header-custom">
            <h5 class="modal-title" id="exampleModalLongTitle">Update Record For {{appointmentId}}</h5>
            <button type="button" (click)="modal.close('Save click')">
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
          <div class="modal-body">
            
             
                  <!-- popup form start -->
  
                  <form [formGroup]="outboundForm" (ngSubmit)="submitOutboundForm(outboundForm.value)">
  
                      <div class="form-row">
                        <div class="form-group col-md-4">
                          <label for="inputEmail4">Passanger Name</label>
                          <input type="text" class="form-control" readOnly formControlName="name" id="inputEmail4">
                        </div>
                        <div class="form-group col-md-4">
                          <label for="inputPassword4">Passport No.</label>
                          <input type="text" class="form-control" readOnly formControlName="passportNumber" id="inputPassword4">
                        </div>
                        <div class="form-group col-md-4">
                          <label for="inputEmail4">Email</label>
                          <input type="email" class="form-control" readOnly formControlName="email" id="inputEmail4">
                        </div>
                      </div>
   
                      
                      <div class="form-row">
                          <div class="form-group col-md-4">
                            <label for="inputPassword4">Phone No.</label>
                            <input type="text" class="form-control" readOnly formControlName="phone" id="inputPassword4">
                          </div>
                          <div class="form-group col-md-4">
                            <label for="inputEmail4">Departure Date</label>
                            <input type="date" formControlName="departureDate" class="form-control" id="inputEmail4"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; outboundForm.controls.departureDate.errors }">
                              <div *ngIf="submitted &amp;&amp; outboundForm.controls.departureDate.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="outboundForm.controls.departureDate.errors.required"> Departure Date is required</div>
                              </div>
                          </div>
                          <div class="form-group col-md-4">
                            <label for="inputPassword4">Collection Center</label>
                            <select type="date" formControlName="center" class="form-control" id="inputPassword4"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; outboundForm.controls.center.errors }">

                              <option value="">Select Collection Center</option>
                              <option *ngFor="let center of collectionCenters?.data" value="{{center?.id}}">{{center.name }} </option>  
                            </select>
                              <div *ngIf="submitted &amp;&amp; outboundForm.controls.center.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="outboundForm.controls.center.errors.required"> Collection Center is required</div>
                              </div>
                          </div>
                        </div>
  
  
  
  
                        <div class="form-row">
                          <div class="form-group col-md-3">
                            <label for="preferState">Preferred State</label>
                            <input id="preferState" formControlName="preferredState" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; outboundForm.controls.preferredState.errors }">
                              <div *ngIf="submitted &amp;&amp; outboundForm.controls.preferredState.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="outboundForm.controls.preferredState.errors.required"> Preferred State is required</div>
                              </div>
                          </div>
                          <div class="form-group col-md-3">
                              <label for="inputState">LGA</label>
                              <select id="inputState" formControlName="lga" class="form-control"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; outboundForm.controls.lga.errors }">
                              
                              <option value="">Select Preferred Test LGA</option>
                              <option *ngFor="let lga of lgas" value="{{lga?.id}}">{{lga.name }} {{lga?.lga_code}}</option>  
                            </select>
                              <div *ngIf="submitted &amp;&amp; outboundForm.controls.lga.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="outboundForm.controls.lga.errors.required"> LGA is required</div>
                              </div>
                            </div>
                          <div class="form-group col-md-3">
                            <label for="inputPassword4">Booking Date</label>
                            <input type="Date" class="form-control" formControlName="bookingDate" id="inputPassword4"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; outboundForm.controls.bookingDate.errors }">
                              <div *ngIf="submitted &amp;&amp; outboundForm.controls.bookingDate.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="outboundForm.controls.bookingDate.errors.required"> Booking Date is required</div>
                              </div>
                          </div>
                          <div class="form-group col-md-3">
                              <label for="inputPassword4">Booking Time</label>
                              <input type="time" class="form-control" formControlName="bookingTime" id="inputPassword4"
                              [ngClass]="{ 'is-invalid': submitted &amp;&amp; outboundForm.controls.bookingTime.errors }">
                              <div *ngIf="submitted &amp;&amp; outboundForm.controls.bookingTime.errors"
                                  class="form-text text-danger">
                                  <div *ngIf="outboundForm.controls.bookingTime.errors.required"> Booking Time is required</div>
                              </div>
                            </div>
                        </div>
  
   
                     
                        <div class=" text-center pb-5">
                          
                          <button type="submit" class="theme_btn tp_two logo-button-website  ">Save changes</button>
                        </div>
                    </form>
  
                  <!-- popup form end--> 
          </div>
        </div>
      </div>
    </div>

  </ng-template>

